import { differenceInCalendarMonths } from "date-fns";
var diffBetwDateInMonths = function (beginningDate, endDate) {
    if (endDate && beginningDate) {
        return differenceInCalendarMonths(new Date(endDate), new Date(beginningDate));
    }
    return 1;
};
export default diffBetwDateInMonths;
//# sourceMappingURL=diffBetwDateInMonths.js.map